const Required = () => {
    return (
        <span className="required-component required"> *</span>
    )
}
export default Required;
